export default __webpack_public_path__ + "static/media/by_receiver.c68cdd11.svg";